import { useSharedCheckoutContext } from '@root/components/checkout/context';

export const useFeeInfo = () => {
  const {
    flowState: { values },
    pricingSummary,
  } = useSharedCheckoutContext();
  const { bundleKind } = values;

  const selectedStorageBundle = pricingSummary?.bundles?.find(
    (bundle) => bundle.kind === bundleKind,
  );

  const onboardingFeeAmount = pricingSummary?.onboardingFeeAmount ?? 0;
  const finalFeeAmount = pricingSummary?.finalReturnFeeAmount ?? 0;
  const gasFeeAmount = pricingSummary?.gasFeeAmount ?? 0;
  const bundleFeeAmount = selectedStorageBundle?.packageSetEntry?.amount ?? 0;
  const totalFeeAmount =
    onboardingFeeAmount + finalFeeAmount + gasFeeAmount + bundleFeeAmount;

  return {
    onboardingFeeAmount,
    finalFeeAmount,
    gasFeeAmount,
    bundleFeeAmount,
    totalFeeAmount,
  };
};
